// @flow

import React from "react";
import type { SelectCourseProps } from "../../utils/_types.js";
// import Select from 'react-select';
import { arrayOf, func, string } from "prop-types";

const SelectCourses = ({
  courseTypes,
  course_type,
  onUpdateSelect,
  translations,
  vocabulary,
}: SelectCourseProps) => {
  // const options = courseTypes.map(type => {
  //   return { value: type, label: type };
  // });
  // const value = options.filter(option => course_type === option.value);
  return (
    <div className="select-course">
      {/* <Select value={value[0]} onChange={onUpdateSelect} options={options} /> */}
      <select
        id="course_type"
        name="course_type"
        onChange={(e) => onUpdateSelect(e.target.value)}
        value={course_type && course_type.length ? course_type : ""}
      >
        <option value="">
          {translations && translations.course_course_type_label
            ? translations.course_course_type_label
            : "-"}
        </option>
        {courseTypes.map((type) => (
          <option value={type} key={`course-select-${type}`}>
            {vocabulary.CourseTypes[type]}
          </option>
        ))}
      </select>
    </div>
  );
};

SelectCourses.propTypes = {
  courseTypes: arrayOf(string),
  course_type: string,
  onUpdateSelect: func,
};

export default SelectCourses;
